import {
  faCheckCircle,
  faDownload,
  faExclamationCircle,
  faUpload,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCallback, useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import axiosInstance from "src/core/api/axiosClient";
import { B2Button, B2Card, B2Col, B2Row } from "src/shared/@hdb/biome-2";
import ContentHeader from "src/shared/content-header/content-header.component";
import ProgressBarModalComponent from "src/core/components/modal/progress-bar-modal.component";
import TableComponent from "src/core/components/table/table.component";
import { toast } from "react-toastify";

type responseMessageType = {
  type: "warning" | "success";
  message: string;
};
type assetInfoType = {
  totalAssets: string;
  newAssets: string;
  oldAssets: string;
  unusedAssets: [];
};
const VerifyMasterDataComponent = () => {
  const pageSize = 10;
  const [pageNumber, setPageNum] = useState<number>(1);
  const [pageNumberUnusedAsset, setPageNumberUnusedAsset] = useState<number>(1);

  const [progress, setProgress] = useState<number>(0);
  const [file, setFile] = useState(null as any);
  const [paginatedFaultyAssets, setPaginatedFaultyAssets] = useState<any>([]);
  const [paginatedUnssedAssets, setPaginatedUnssedAssets] = useState<any>([]);

  const [faultyAssets, setFaultyAssets] = useState<any[]>([]);
  const [isSuccessfullyVerified, setIsSuccessfullyVerified] =
    useState<boolean>(false);

  const [isImporting, setIsImporting] = useState<boolean>(false);
  const [isExporting, setIsExporting] = useState<boolean>(false);
  const [showProgressModal, setShowProgressModal] = useState<boolean>(false);
  const [responseMessage, setResponseMessage] = useState<responseMessageType>({
    type: "warning",
    message: "",
  });

  const [assetInfo, setAssetInfo] = useState<assetInfoType>({
    totalAssets: "",
    newAssets: "",
    oldAssets: "",
    unusedAssets: [],
  });

  const [columns, setColumns] = useState([
    {
      title: "Asset ID",
      label: "assetCode",
      isSorted: true,
      linkableField: "assetCode",
    },
    {
      title: "Message",
      label: "message",
    },
  ]);

  const [columnsUnusedAssets, setColumnsUnusedAssets] = useState([
    {
      title: "Asset ID",
      label: "assetCode",
      isSorted: true,
      linkableField: "assetCode",
    },
  ]);

  const emptyConfigUnusedAssets = {
    title: "No Unused Assets Found",
    description: "Upload Master Data to Verify",
  };

  const emptyConfig = {
    title: "No Issue Found",
    description: "Upload Master Data to Verify",
  };

  const handleChangePage = useCallback((page: number): void => {
    setPageNum(page);
  }, []);

  const handleChangePageUnusedAssets = useCallback((page: number): void => {
    setPageNumberUnusedAsset(page);
  }, []);

  useEffect(() => {
    const startIndex = (pageNumber - 1) * pageSize;
    const endIndex = startIndex + pageSize;

    const paginatedData = faultyAssets.slice(startIndex, endIndex);

    setPaginatedFaultyAssets(paginatedData);
  }, [faultyAssets, pageNumber]);

  useEffect(() => {
    const startIndex = (pageNumberUnusedAsset - 1) * pageSize;
    const endIndex = startIndex + pageSize;

    const paginatedData = assetInfo.unusedAssets.slice(startIndex, endIndex);

    setPaginatedUnssedAssets(paginatedData);
  }, [assetInfo.unusedAssets, pageNumberUnusedAsset]);

  const onClickVerifyMasterData = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.files && event.target.files.length > 0) {
      setFile(event.target.files[0]);
      setProgress(0);

      try {
        const formData = new FormData();
        formData.append("file", event.target.files[0]);

        setIsImporting(true);

        await axiosInstance
          .post(`/slpapp/assetverification/verifyassetfile`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            onUploadProgress: (progressEvent) => {
              const { loaded, total } = progressEvent;
              if (total !== null && total !== undefined) {
                const percentCompleted = Math.round((loaded * 100) / total);
                setProgress(percentCompleted);
              }
            },
          })
          .then((response: any) => {
            setIsImporting(false);

            if (response?.data?.data?.assetCodeInfos?.length > 0) {
              const assetCodeInfosData =
                response?.data?.data?.assetCodeInfos[0];
              setAssetInfo({
                totalAssets: assetCodeInfosData?.totalAssetCodesFile,
                newAssets: assetCodeInfosData?.newAssetCodes,
                oldAssets: assetCodeInfosData?.oldAssetCodes,
                unusedAssets: assetCodeInfosData?.unusedAssetCodes,
              });
            }

            if (response?.data?.status === 400) {
              setResponseMessage({
                type: "warning",
                message:response?.data?.message,
              });
              return;
            } else if (
              response?.data?.data?.assetUploadValidationDetails?.length > 0
            ) {
              setFaultyAssets(
                response?.data?.data?.assetUploadValidationDetails
              );

              toast.warning(
                "Master data is verified and found issues, Check them out in the table",
                {
                  position: "top-right",
                  autoClose: 3000,
                  hideProgressBar: false,
                  closeOnClick: false,
                  pauseOnFocusLoss: true,
                  draggable: true,
                  pauseOnHover: true,
                }
              );

              setResponseMessage({
                type: "warning",
                message:
                  "Please find below a list of assets that have been identified with issues. Kindly click on the 'Export Asset' button to download the file containing the marked faulty assets. After reviewing and addressing the necessary corrections, please recheck the file.",
              });
            } else {
              toast.success(
                "Master Data is verified successfully and Found everything OK!",
                {
                  position: "top-right",
                  autoClose: 3000,
                  hideProgressBar: false,
                  closeOnClick: false,
                  pauseOnFocusLoss: true,
                  draggable: true,
                  pauseOnHover: true,
                }
              );

              setResponseMessage({
                type: "success",
                message:
                  "Master data is verified and Found OK. Kindly click on the 'Convert to Standard Master File' button to download the Standard Master File",
              });

              setFaultyAssets([]);
              setIsSuccessfullyVerified(true);
            }
          })
          .catch((error: any) => {
            setIsImporting(false);
            setIsSuccessfullyVerified(false);
            setProgress(0);
            console.log("error uploading file: ", error);
          });
      } catch (error) {
        setProgress(0);
        setIsImporting(false);
        setIsSuccessfullyVerified(false);
        console.error("Error uploading file:", error);
        throw error;
      }
    }

    event.target.value = "";
  };

  useEffect(() => {
    if (progress > 0 && progress < 100) {
      setShowProgressModal(true);
    } else if (progress == 100) {
      setShowProgressModal(true);

      setTimeout(() => {
        setShowProgressModal(false);
        // document.body.classList.add("loading-indicator");
      }, 500);
    } else {
      setShowProgressModal(false);
    }
  }, [progress]);

  const onClickExport = async () => {
    if (file && faultyAssets?.length > 0) {
      try {
        const formData = new FormData();
        formData.append("file", file);

        setIsExporting(true);

        await axiosInstance
          .post(`/slpapp/assetverification/downloadassetfile`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            responseType: "blob",
          })
          .then((response: any) => {
            setIsExporting(false);

            let filename = response.headers["content-disposition"]
              .split(";")
              .find((n: any) => n.includes("filename="))
              .replace("filename=", "")
              .trim();

            const fileBlob = new Blob([response.data], {
              type: "application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            const fileUrl = URL.createObjectURL(fileBlob);

            const link = document.createElement("a");
            link.href = fileUrl;

            link.download = filename;

            link.click();

            URL.revokeObjectURL(fileUrl);

            return response.data;
          })
          .catch((error: any) => {
            setIsExporting(false);
            console.log("Error downloading varified assets file: ", error);
          });
      } catch (error) {
        setIsExporting(false);
        console.error("Error downloading varified assets file:", error);
        throw error;
      }
    }
  };

  const onClickConvertToMasterFile = async () => {
    if (file && faultyAssets?.length == 0) {
      try {
        const formData = new FormData();
        formData.append("file", file);

        setIsExporting(true);

        await axiosInstance
          .post(`/slpapp/assetverification/downloadMasterassetfile`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            responseType: "blob",
          })
          .then((response: any) => {
            setIsExporting(false);

            let filename = response.headers["content-disposition"]
              .split(";")
              .find((n: any) => n.includes("filename="))
              .replace("filename=", "")
              .trim();

            const fileBlob = new Blob([response.data], {
              type: "application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            const fileUrl = URL.createObjectURL(fileBlob);

            const link = document.createElement("a");
            link.href = fileUrl;

            link.download = filename;

            link.click();

            URL.revokeObjectURL(fileUrl);

            return response.data;
          })
          .catch((error: any) => {
            setIsExporting(false);
            console.log("Error downloading master asset file: ", error);
          });
      } catch (error) {
        setIsExporting(false);
        console.error("Error downloading master assets file:", error);
        throw error;
      }
    }
  };

  return (
    <div>
      <div className="header-container">
        <div className="title-container">
          <ContentHeader pageTitle="Verify Master Data"></ContentHeader>
        </div>
      </div>
      <div className="page">
        <div className="page-container mt-4">
          <div className="d-flex gap-3 justify-content-end table-generic-action">
            <div className="d-flex justify-content-end table-generic-action">
              {file && faultyAssets.length > 0 && (
                <B2Button
                  className="me-2 icon-text-btn"
                  variant="primary"
                  onClick={() => onClickExport()}
                >
                  {isExporting ? (
                    <Spinner
                      animation="border"
                      variant="info"
                      size="sm"
                      className="me-2"
                    />
                  ) : (
                    <FontAwesomeIcon icon={faDownload} className="me-2" />
                  )}
                  Export Asset
                </B2Button>
              )}

              <B2Button className="icon-text-btn" variant="primary">
                <FontAwesomeIcon icon={faUpload} className="" />
                <label htmlFor="upload" className="ms-2 cursor-pointer">
                  Verify Master Data{" "}
                  <input
                    id="upload"
                    type="file"
                    className="d-none"
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                      onClickVerifyMasterData(event);
                    }}
                  />
                </label>
              </B2Button>

              {file && faultyAssets?.length == 0 && isSuccessfullyVerified && (
                <B2Button
                  className="ms-2 icon-text-btn"
                  variant="primary"
                  onClick={() => onClickConvertToMasterFile()}
                >
                  {isExporting ? (
                    <Spinner
                      animation="border"
                      variant="info"
                      size="sm"
                      className="me-2"
                    />
                  ) : (
                    <FontAwesomeIcon icon={faDownload} className="me-2" />
                  )}
                  Convert to Standard Master File
                </B2Button>
              )}
            </div>
          </div>
          <div className="my-3">
            <div className="mt-8">
              {responseMessage?.type === "success" &&
                responseMessage?.message && (
                  <>
                    <div className="alert alert-success d-flex align-items-center p-3 rounded shadow-sm">
                      <FontAwesomeIcon
                        icon={faCheckCircle}
                        className="me-3 text-success"
                        size="lg"
                      />
                      <div>
                        <strong>Success:</strong> {responseMessage?.message}
                      </div>
                    </div>

                    <div>
                      {/* first part */}
                      <div className="mb-4">
                        {/* <div className="mb-3 fs-3"><strong>Asset Insight:</strong> </div> */}

                        <B2Col xs={12} lg={12} className="mb-3 mb-lg-0 ">
                          <B2Card className="p-3">
                            <B2Row className="d-flex align-items-center">
                              {/* Total Assets Section */}
                              <h4 className="fw-bold mb-3 text-center d-block d-sm-none">
                                Town Council Overview
                              </h4>
                              <B2Col
                                xs={12}
                                md={3}
                                className="d-md-flex justify-content-between"
                              >
                                <div className="d-flex flex-column align-items-center justify-content-center text-center text-md-start mb-5 mb-sm-0">
                                  <div className="d-flex gap-4">
                                    <div className="d-flex flex-column">
                                      <h1 className="m-0 textNeutral600 fw-bold">
                                        {assetInfo?.totalAssets || 0}
                                      </h1>

                                      <p className="m-0 textNeutral600 fw-medium">
                                        Total Assets
                                      </p>
                                    </div>
                                  </div>
                                </div>

                                <div className="vertical-dashed-line d-none d-md-block"></div>
                              </B2Col>

                              {/* Old Assets Section */}
                              <B2Col
                                xs={12}
                                md={3}
                                className="d-md-flex justify-content-between"
                              >
                                <div className="d-flex flex-column align-items-center justify-content-center text-center text-md-start mb-5 mb-sm-0">
                                  <div className="d-flex gap-4">
                                    <div className="d-flex flex-column">
                                      <h1 className="m-0 textNeutral600 fw-bold">
                                        {assetInfo?.oldAssets || 0}
                                      </h1>

                                      <p className="m-0 textNeutral600 fw-medium text-warning">
                                        Old Assets
                                      </p>
                                    </div>
                                  </div>
                                </div>

                                <div className="vertical-dashed-line d-none d-md-block"></div>
                              </B2Col>

                              {/* New Assets Section */}
                              <B2Col
                                xs={12}
                                md={3}
                                className="d-md-flex justify-content-between"
                              >
                                <div className="d-flex flex-column align-items-center justify-content-center text-center text-md-start mb-5 mb-sm-0">
                                  <div className="d-flex gap-4">
                                    <div className="d-flex flex-column">
                                      <h1 className="m-0 textNeutral600 fw-bold">
                                        {assetInfo?.newAssets || 0}
                                      </h1>

                                      <p className="m-0 textNeutral600 fw-medium text-success">
                                        New Assets
                                      </p>
                                    </div>
                                  </div>
                                </div>

                                <div className="vertical-dashed-line d-none d-md-block"></div>
                              </B2Col>

                              {/* Unused Assets Section */}
                              <B2Col
                                xs={12}
                                md={3}
                                className="d-flex flex-column align-items-center align-items-lg-start justify-content-center text-center text-md-start mb-5 mb-sm-0"
                              >
                                <div className="d-flex gap-4">
                                  <div className="d-flex flex-column">
                                    <h1 className="m-0 textNeutral600 fw-bold">
                                      {assetInfo?.unusedAssets?.length || 0}
                                    </h1>

                                    <p className="m-0 textNeutral600 fw-medium text-danger">
                                      Unused Assets
                                    </p>
                                  </div>
                                </div>
                              </B2Col>
                            </B2Row>
                          </B2Card>
                        </B2Col>
                      </div>

                      {/* table part */}
                      {assetInfo?.unusedAssets?.length > 0 && (
                        <div>
                          <div className="mb-3 fs-3">
                            <strong>Unused Assets List:</strong>{" "}
                          </div>

                          <TableComponent
                            tableHeaders={columnsUnusedAssets}
                            emptyConfig={emptyConfigUnusedAssets}
                            data={paginatedUnssedAssets}
                            totalNumberOfRecords={
                              assetInfo?.unusedAssets?.length
                            }
                            pageSize={pageSize}
                            current={pageNumberUnusedAsset}
                            onChangePage={handleChangePageUnusedAssets}
                            isLoadingData={isImporting}
                          />
                        </div>
                      )}
                    </div>
                  </>
                )}

              {responseMessage?.type === "warning" &&
                responseMessage?.message && (
                  <div className="alert alert-warning d-flex align-items-center p-3 rounded shadow-sm">
                    <FontAwesomeIcon
                      icon={faExclamationCircle}
                      className="me-3 text-warning"
                      size="lg"
                    />
                    <div>
                      <strong>Warning:</strong> {responseMessage?.message}
                    </div>
                  </div>
                )}
            </div>

            {responseMessage?.type !== "success" && (
              <TableComponent
                tableHeaders={columns}
                emptyConfig={emptyConfig}
                data={paginatedFaultyAssets}
                totalNumberOfRecords={faultyAssets?.length}
                pageSize={pageSize}
                current={pageNumber}
                onChangePage={handleChangePage}
                isLoadingData={isImporting}
              />
            )}
          </div>
        </div>
      </div>

      {/* modals */}

      {showProgressModal && (
        <ProgressBarModalComponent
          showModal={showProgressModal}
          progress={progress}
        />
      )}
    </div>
  );
};

export default VerifyMasterDataComponent;
